import apptracker from '@utils/sensor/apptracker';

// list of events we don't want to track any more
const deprecated = [];

// value injected during building
const mode = process.env.logMode;

function track(props) {
  const { event, data } = props;
  if (!event || deprecated.includes(event)) {
    return;
  }
  switch (mode) {
    case 'console':
      window.console.log(props);
      break;
    default:
  }

  // push events to sensor
  apptracker(event, data);
}
export default track;

export const CLICK_COMPARE = 'Click Compare';
export const CLICK_TOP_TRENDS_BY = 'Click Top Trends By';
export const CLICK_DIAGNOSTICS = 'Click Diagnostics';
export const APPLY_METRICS = 'Apply Metrics in Dimension Panel';
export const CLICK_FILTERS = 'Click Filters Dropdown';
export const APPLY_DRILL_DOWN = 'Apply drill-down filter';

export const CLICK_DATE_COMPARISON_ON = 'Click Visual Time Shift ON';
export const CLICK_DATE_COMPARISON_OFF = 'Click Visual Time Shift OFF';
export const CLICK_CLOSE_DIAGNOSTICS = 'Click on Close Diagnostics';

export const CLICK_EXPORT_COMPARE_DASHBOARD = 'Click Export Compare Dashboard';
export const CLICK_EXPORT_ERROR_DIAGNOSTICS = 'Click Export Error Diagnostics';
export const CLICK_EXPORT_WIDGET_TRENDS_METRIC = 'Click Export Widget Trends Metric';
export const CLICK_EXPORT_WIDGET_TRENDS_ALL_METRICS = 'Click Export Widget Trends All Metrics';
export const CLICK_EXPORT_TRENDS = 'Click Export Trends';

export const CLICK_EXPORT_WIDGET_ERROR_BIRD_CHART = 'Click Export Widget Error Bird Chart';
export const CLICK_EXPORT_WIDGET_ERROR_BAR_CHART = 'Click Export Widget Error Bar Chart';
export const CLICK_EXPORT_TRENDS_VIEWER_DRILLDOWN_DISTRIBUTION =
  'Click Export trends viewer drilldown distribution';
export const CLICK_EXPORT_WIDGET_TRENDS_DIAGNOSTICS = 'Click Export widget trends Diagnostics';
export const CLICK_EXPORT_WIDGET_COMPARE = 'Click export widget compare';
export const CLICK_EXPORT_WIDGET_TRENDS_SESSIONS = 'Click export widget trends sessions';
export const CLICK_EXPORT_WIDGET_ERROR_TOP_TRENDS_ERROR_TABLE =
  'Click export widget error top trends table';
export const CLICK_EXPORT_WIDGET_TRENDS_DIMENSIONS = 'Click export widget trends dimensions';

export const CLICK_ALL_METRICS_PANEL_APPLY = 'Click all metrics panel apply';
export const CLICK_DATE_COMPARISON = 'Click date comparison';

export const CLICK_SAVE_REORDER_POLICIES = 'Click on save reordering of policies';
export const CLICK_SAVE_ACTIVATE_POLICY_NOW = 'Click on activate precision policy now';
export const CLICK_SAVE_SCHEDULE_POLICY = 'Click on save schedule precision policy';
export const CLICK_EDIT_ACTIVATE_POLICY_NOW = 'Click on edit and activate precision policy now';
export const CLICK_EDIT_SCHEDULE_POLICY = 'Click on edit precision policy schedule';
export const CLICK_DELETE_SCHEDULE_POLICY = 'Click on delete precision policy schedule';
export const CLICK_SCHEDULE_POLICY_LIST_VIEW = 'Click on scheduled policies list view';
export const CLICK_SCHEDULE_POLICY_CALENDAR_VIEW = 'Click on scheduled policies calendar view';

export const CLICK_ML_NEW_FILTER = 'Click on MetricLens new filter';
export const CLICK_ML_LIVE = 'Click on MetricLens live.';
export const CLICK_ML_DIMENSION_CHANGE = 'Click on MetricLens dimension change';
export const CLICK_ML_METRICS_CHANGE = 'Click on MetricLens metrics change';
export const CLICK_ML_CHART_MODE_CHANGE = 'Click on MetricLens chart mode change';
export const CLICK_ML_UNIT_MODE_CHANGE = 'Click on MetricLens unit mode change';
export const CLICK_ML_DATETIME_INTERVAL_CHANGE = 'Click on MetricLens date time interval change';
export const CLICK_ML_SORTING = 'Click on MetricLens sorting';
export const CLICK_ML_FILTER_CLOSE = 'Click on MetricLens filter close';

export const AUTO_INSIGHTS_DRAWER = 'Opened auto insights drawer';
export const AUTO_INSIGHTS_SETTINGS = 'Clicked on auto insights settings';
export const AUTO_INSIGHTS_ALERT_CLICK = 'Clicked on auto insights AI alert record';
export const AUTO_INSIGHTS_ALERTS_MORE = 'Clicked on auto insights AI alert more link';
export const ALERT_INSIGHTS = 'Clicked on alert summary insights link';
export const AUTO_INSIGHTS_BROKENASSET_CLICK = 'Clicked on auto insights Broken Asset record';
export const AUTO_INSIGHTS_NEWAPPVERSION_CLICK = 'Clicked on auto insights New App Version record';

export const CHANGED_TIME_GRANULARITY = 'Changed time granularity';
export const CHANGED_METRIC_PANEL_LAYOUT = 'Changed metric panel layout';
export const WHATS_NEW_HELP = 'Clicked whats new button';
export const TRY_APP_INSIGHTS = 'Clicked try app insights button';

export const SELECTED_CHART_METRIC = 'Selected chart metric';
export const CLICK_CHART_TOOL = 'Clicked on chart tool';
export const CLICK_CHART_MODE = 'Clicked on chart mode';
export const CHANGE_CHART_SIZE = 'Changed chart size';
export const CHANGE_CHART_UNIT = 'Changed chart unit';
export const REMOVE_CHART = 'Removed chart';
export const SELECTED_SUMMARY_PANEL_METRIC = 'Selected summary panel metric';
export const CLICK_SUMMARY_PANEL_COLLAPSE = 'Clicked on summary panel collapse';

export const CLICK_SHARE_FROM_KEBAB = 'Click on Share from kebab menu';
export const CLICK_SAVE_FROM_KEBAB = 'Click on Save (Beta) dashboard from the kebab menu';
export const CLICK_ON_UPDATE_DASHBOARD = 'Click on Update (Beta) dashboard from the kebab menu';
export const CLICK_ON_DELETE_DASHBOARD = 'Click on Delete (Beta) dashboard from the kebab menu';
export const CLICK_ON_PRIVATE_PUBLIC_CHECKBOX = 'Make it public/private';
export const CANCEL_SAVE_DASHBOARD_POPUP = 'Cancel save dashboard popup';
export const CANCEL_UPDATE_DASHBOARD_POPUP = 'Cancel update dashboard popup';
export const CANCEL_DELETE_DASHBOARD_POPUP = 'Cancel delete dashboard popup';
export const CLICK_SAVED_DASHBOARD_TABS = 'Click on saved dashboard tabs';
export const CLICK_SAVED_DASHBOARD_COLUMN_SORT = 'Click on saved dashboard column sort';
export const CLICK_SHARE_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - share';
export const CLICK_EDIT_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - edit';
export const CLICK_DELETE_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - delete';
export const CLICK_SAVED_DASHBOARD_FROM_TABS_DROPDOWN =
  'Saved dashboards accessed from the tabs dropdown';
export const CLICK_SAVED_DASHBOARD_FROM_NAV_MENU_DROPDOWN =
  'Saved dashboards accessed from the navigation menu dropdown';
export const CLICK_ON_CLOSE_UNSAVED_DASHBOARD = 'Closing an unsaved dashboard';
export const USER_FEEDBACK = 'user feedback';

export const APP_TRIAL_REQUEST = 'App Insights Trial Request';

export const PRESET_USECASE = 'preset usecase';
export const TOGGLE_ERROR_FILTER = 'toggle error filter';

export const PROMPT_FEEDBACK = 'Prompt Feedback';
export const PROMPT_QUESTION = 'Prompt Question';
export const PROMPT_ANSWER = 'Prompt Answer';
export const PROMPT_ERROR = 'Prompt Error in UI';
export const PROMPT_COPY_ANSWER = 'Prompt Copy';

export const QUICK_COMPARE = 'Quick compare toggle';
export const APPLY_COMPARE = 'Apply Compare';

// compare dashboard migration
export const COMPARE_MIGRATION = 'compare dashboard migration';
export const MIGRATED_COMPARE_DASHBOARD = 'migrated compare dashboard';
export const COMPARE_MIGRATION_ERROR = 'compare dashboard migration error';

// error diag dashboard migration
export const ERROR_DIAG_MIGRATION = 'error diag dashboard migration';
export const MIGRATED_ERROR_DIAG_DASHBOARD = 'migrated error diag dashboard';
export const ERROR_DIAG_MIGRATION_ERROR = 'error diag dashboard migration error';

// Filter Management
export const OPEN_FILTER_MANAGEMENT_PANEL = 'Open Filter Management Panel';
export const CREATE_FILTER_ON_FILTER_MANAGEMENT = 'Create Filter On Filter Management Panel';
export const DELETE_FILTER_ON_FILTER_MANAGEMENT = 'Delete Filter On Filter Management Panel';
//Geo Map
export const TOGGLE_TO_MAP_VIEW = 'Toggle To Map View';
export const CLICK_EXPORT_RESILIENCY_TABLE = 'Click Export Resiliency Table';
export const NEW_RESILIENCY_DASHBOARD_PAGE_VIEWED = 'New Resiliency Dashboard Page Viewed';
